import React, { useState } from 'react';
import Modal, {
  ModalBody,
  ModalContent,
  ModalHeader,
} from '../../../../components/modal/Modal';
import FetchTrimFeatureCompare from '../features/FetchTrimFeatureCompare';
import TrimCompare from '../../../../components/compareManager/TrimCompare';
import useCompareModalScrolling, {
  useCompareModalIsScrolledUp,
} from '../../../../components/compareManager/useCompareModalScrolling';
import { useTranslate } from '../../../../../core/translate';

const TrimCompareModal = (props) => {
  const {
    onClose,
    onSelect,
    config,
    modelInfo,
    postalCode,
    selections,
    trimGroups,
    isSelectionRevealed,
    filter,
    hasCabSizes,
    keyFeatureSelections = [],
  } = props;
  const [contentRef, setContentRef] = useState(null);
  const translate = useTranslate();

  const analyticsKey = 'compare trims';
  const header = translate('compare.trims.title.v3', {
    title: modelInfo.title,
  });

  const [scrolling] = useCompareModalScrolling(
    contentRef && contentRef.querySelector('.trim-compare__modal-body')
  );
  const [isScrolledUp, setIsScrolledUp] = useCompareModalIsScrolledUp(
    contentRef && contentRef.querySelector('.trim-compare__modal-body')
  );

  return (
    <Modal
      isOpen={true}
      contentLabel={header}
      onRequestClose={onClose}
      contentRefCallback={(node) => setContentRef(node)}>
      <ModalHeader
        text={header}
        analyticsKey={analyticsKey}
        onClose={onClose}
      />
      <ModalBody
        className="trim-compare__modal-body"
        innerClassName="compare__nav-padding">
        <ModalContent>
          <FetchTrimFeatureCompare
            config={config}
            postalCode={postalCode}
            render={({ features }) => (
              <TrimCompare
                config={config}
                features={features}
                selectedTrim={selections}
                onClose={onClose}
                onSelect={onSelect}
                trimGroups={trimGroups}
                isScrolled={scrolling}
                isScrolledUp={isScrolledUp}
                setIsScrolledUp={setIsScrolledUp}
                hasCabSizes={hasCabSizes}
                isSelectionRevealed={isSelectionRevealed}
                filter={filter}
                keyFeatureSelections={keyFeatureSelections}></TrimCompare>
            )}></FetchTrimFeatureCompare>
        </ModalContent>
      </ModalBody>
    </Modal>
  );
};

export default TrimCompareModal;
